/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Stage_VerifyInputs */

const en_directory_hubs_signals_ai_stage_verify = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiability: structured output, success signals, rate limits, and versioning an agent checks its own work against. 5 checks.`)
};

const zh_directory_hubs_signals_ai_stage_verify = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可验证性：结构化输出、成功信号、速率限制与版本管理，供 Agent 核对自己的工作。5 项检查。`)
};

/**
* | output |
* | --- |
* | "Verifiability: structured output, success signals, rate limits, and versioning an agent checks its own work against. 5 checks." |
*
* @param {Directory_Hubs_Signals_Ai_Stage_VerifyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_stage_verify = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Stage_VerifyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Stage_VerifyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_stage_verify(inputs)
	return zh_directory_hubs_signals_ai_stage_verify(inputs)
});
export { directory_hubs_signals_ai_stage_verify as "directory.hubs.signals.ai.stage.verify" }